import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { contactInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section">
            <div className="footer-brand">
              <img 
                src="https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/4c93wpot_f1c1dc3fdad4c20d2af91de1fd3271d5efc3779d.png" 
                alt="NDV Motors Logo" 
                className="footer-logo"
              />
            </div>
            <p className="footer-tagline">L'excellence de votre véhicule</p>
            <p className="footer-description">
              Garage automobile premium spécialisé en carrosserie, peinture et rénovation esthétique à Yutz.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Navigation</h3>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/galerie">Galerie</Link></li>
              <li><Link to="/a-propos">À Propos</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-title">Nos Services</h3>
            <ul className="footer-links">
              <li>Carrosserie Automobile</li>
              <li>Peinture Professionnelle</li>
              <li>Réparation Après Sinistre</li>
              <li>Jantes Haut de Gamme</li>
              <li>Rénovation Esthétique</li>
              <li>Conseil Personnalisé</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-title">Contact</h3>
            <ul className="footer-contact">
              <li>
                <MapPin size={18} />
                <span>{contactInfo.address}<br />{contactInfo.city}</span>
              </li>
              <li>
                <Phone size={18} />
                <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}>{contactInfo.phone}</a>
              </li>
              <li>
                <Mail size={18} />
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </li>
              <li>
                <Instagram size={18} />
                <a href={contactInfo.instagramUrl} target="_blank" rel="noopener noreferrer">
                  {contactInfo.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} NDV Motors. Tous droits réservés.</p>
          <p className="footer-credit">Garage automobile premium à Yutz - Carrosserie, Peinture, Jantes</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
